module.exports = __webpack_public_path__ + "static/media/breedCut-03.8746dcc2.png";